import { Component, OnInit, OnDestroy, ViewEncapsulation } from "@angular/core";
import { AuthenticationServices } from "../../../../services/authentication.services";
import { ServiceModelManagerServices } from "../../../../services/service-model-manager.services";
import { MongoVideoServices } from "../../../../services/mongoVideo.services";
import { ActivatedRoute } from "@angular/router";
import { AppEditorServices } from "../../../../services/app-editor.services";
import { AppModalServices } from "../../../../services/app-modal.services";
import { MongoCursorModel } from "../../../../models/mongoCursor.model";
import { LocalStorageServices } from "../../../../services/localStorage.services";

const $ = require('jquery');

@Component({
    selector: 'app-videos',
    template: require('./videos.component.pug'),
    styles: [require('./videos.component.scss')],
    encapsulation: ViewEncapsulation.None
})

export class VideosComponent implements OnInit, OnDestroy {
  private showVideoInformation: any[] = new Array();
  private years: number[] = new Array();
  private months: number[] = new Array();
  private documents: any[] = new Array();
  private total: number;
  private limit: number;
  private isSearch: boolean = false;
  private cursor: MongoCursorModel = new MongoCursorModel('view');
  private videosSubscription: any;
  private tabsSubscription: any;
  private pagination: any = { page: undefined, pages: undefined }

  constructor(
    private formManager: ServiceModelManagerServices,
    private activeUser: AuthenticationServices,
    private activatedRoute: ActivatedRoute,
    private videos: MongoVideoServices,
    private editor: AppEditorServices,
    private modal: AppModalServices,
    private appLocalStorage: LocalStorageServices
  ){}

  ngOnInit (): void {
    this.cursor.set( this.appLocalStorage.get('videoCursor'))
    this.modal.clear();
    this.years = [];
    this.formManager.setService(this.activatedRoute.snapshot.url[0].path);
    this.videos.getTabs({ tab: 'year' })

    this.tabsSubscription = this.videos.onUpdatedTabs.subscribe((updatedTabs: any) => {
      if ( updatedTabs ) {
        const { tabs, type } = updatedTabs;

        if ( type === 'year' ) {
          this.years = tabs.filter( (year: any ) => year);
          const year = this.cursor.get('year');
          if ( !year ) this.cursor.set({ year: this.years[0] } );
          this.videos.getTabs({ year: this.cursor.get('year'), tab: 'month' })
        }

        if ( type === 'month' ) {
          this.months = tabs;
          const cursorMonthinTabs = (tabs.find( (element:any) => element === this.cursor.get('month'))) ? true : false ;
          const month = this.cursor.get('month') || this.cursor.get('month') === 0 ? true : false;
          let ultimateMonth = this.months[this.months.length - 1];
          if ( !month || !cursorMonthinTabs ) this.cursor.set({ month: ultimateMonth } );
          this.moveCursor( this.cursor );
        }
      }
    })

    this.videosSubscription = this.videos.onUpdatedView.subscribe((updatedView: any) => {
      const { isSearch, videos } = updatedView;
      if ( isSearch ) this.pagination = { page: undefined, pages: undefined };
      if ( videos.docs ) {
        const { docs, total, limit, page, pages } = videos;
        this.isSearch = isSearch;
        this.pagination = { page: page, pages: pages };
        this.documents = docs;
        this.total = total;
        this.limit = limit;
      }

    })
  }

  ngOnDestroy():void {
    this.appLocalStorage.set( { videoCursor: this.cursor } );
    this.tabsSubscription.unsubscribe();
    this.videosSubscription.unsubscribe();
  }

  moveCursor( cursorObj: any ): void {
    const { year, month, page } = cursorObj;
    const monthIsZero = month === 0 ? true : false ;

    if ( year && !month && !monthIsZero ) {
      this.videos.getTabs( { year: year, tab: 'month'})
    }

    else if ( ( month || monthIsZero ) && !year ) {
      this.videos.getView( this.cursor );
    }

    else {
      this.isSearch ? this.videos.search( cursorObj ) : this.videos.getView( cursorObj );
    }

  }

  setCursor( event: any ):void {
    const { page, year, month } = event;

    if ( year || month || month === 0) {
      this.cursor.set({ page: 1 });

      if ( year ) {
        this.cursor.set({ year: year, month: undefined })
      }

      else {
        this.cursor.set({ month: Number(month) });
      }

      this.moveCursor( event );
    }

    if ( page ) {
      const { page } = event;
      if ( this.isSearch ) {
        const searchCursor = this.videos.latestSearch;
        searchCursor.set({ page: page });
        this.moveCursor( searchCursor );

      }
      else {
        this.cursor.set({ page: page });
        this.moveCursor( this.cursor );
      }
    }
  }

  setVideoInfobox ( index: number ) {
    index || index === 0 ? this.showVideoInformation[index] = this.documents[index] : this.showVideoInformation = new Array();
  }

  openEditor () : void {
    this.editor.setAssets( this.documents );
    this.editor.setDoEdit();
  }

  openModal ( id: string ): void {
    let index: number;

    this.documents.forEach( ( document, i ) => {
      if ( document._id == id ) index = i;
    })
    this.modal.initialise( this.documents, index );
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/route/private/user-domain/videos/videos.component.ts